/**
 * The equipment module, completed — Phase 11 (decision D156) on the Phase 8
 * register (D85).
 *
 * ===========================================================================
 * READ CLAUDE.md SECTION 4 BEFORE ADDING A FIELD HERE.
 * ===========================================================================
 *
 * The register gains optional descriptive fields — type, manufacturer, model,
 * serial number, location and a responsible person — and calibration gets a
 * HISTORY: an append-only record of what was calibrated when, until when, by
 * whom and under which certificate, in the laboratory's own words.
 *
 * There is deliberately NO pass/fail, "within tolerance", uncertainty or
 * measured-value field anywhere here. Whether a calibration result is
 * acceptable is the provider's statement on the certificate and metrology the
 * product must not invent. Nothing says which instrument a test requires
 * (limitation 26, D95), and there is no calibration-interval policy: a due-soon
 * list is a filter the caller dates (`calibrationDueBy`).
 *
 * THE BLOCKING RULE IS UNCHANGED: `equipmentBlockReason` in `execution.ts`,
 * reading only the instrument's status and its current valid-until date.
 */
/**
 * How a calibration history row came to exist.
 *
 * `record` — a calibration recorded through the history route: the date it
 * was performed is REQUIRED. `date_only` — the Phase 8 "record a valid-until
 * date" act, which now also writes a history row; it says nothing about when a
 * calibration was performed, so its date is not invented — its effective date
 * is the laboratory's today when it was recorded.
 */
export const CALIBRATION_SOURCE = {
    RECORD: 'record',
    DATE_ONLY: 'date_only',
};
export const ALL_CALIBRATION_SOURCES = Object.freeze(Object.values(CALIBRATION_SOURCE));
/**
 * Of several history rows, which one sets the instrument's CURRENT valid-until
 * date: the greatest `(effectiveOn, recordedAt)` (D156). Returns null for an
 * empty history. Recording an older calibration after a newer one therefore
 * never rolls the current date back.
 */
export function currentCalibration(history) {
    let current = null;
    for (const row of history) {
        if (current === null ||
            row.effectiveOn > current.effectiveOn ||
            (row.effectiveOn === current.effectiveOn &&
                Date.parse(row.recordedAt) > Date.parse(current.recordedAt))) {
            current = row;
        }
    }
    return current;
}
//# sourceMappingURL=equipment.js.map